module.exports = __webpack_public_path__ + "static/media/meenakshi_arasada.13fa3eef.png";